// https://material-ui.com/styles/api/#stylesprovider
export const StylesProviderProps = { injectFirst: false };
